/* eslint-disable @typescript-eslint/no-explicit-any */
// axios
import axios, { AxiosError } from "axios"
// API_URL
import {API_URL} from "../constants"

export async function passwordValidationForSensitiveData(email: string , password : string)
{
   try {
      const response = await axios({
         method: "post",
         url: `${API_URL}/usuarios/passwordValidation`,
         data: {email, password},
         withCredentials: true,
         headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-store",
         },
      })
      return response.data
   } catch (err) {
      const error = err as AxiosError

      if (error.response) {
        
         if (error.response.status === 401) {
            
            return {
               status: 401,
               data: error.response.data,
               message: "Unauthorized – invalid credentials or expired session",
            }
         }

         return {
            status: error.response.status,
            data: error.response.data,
         }
      }

      return {
         status: "network_error",
         message: error.message,
      }
   }

}

export async function checkUser(email: string) {
   const user = await axios.get(`${API_URL}/usuarios/usuario/${email}`)
   return user
}

interface User {
   email: string
   nombre: string
   telefono: string
   type: any
}

export async function AddUser(user: User, headers: any) {
   const userAdded = await axios({
      method: "post",
      url: `${API_URL}/usuarios/usuario`,
      data: user,
      headers,
      withCredentials: true,
   })
   return userAdded
}

/**Front endpoint to call the collection of users in NoSQL Database */

export async function getAllUser(limit:number,cursor?:string|null)
{
   const users = await axios({
      method : "get",
      params : {limit : limit , cursor : cursor},
      url : `${API_URL}/usuarios/`,
      headers: {
         "Content-Type": "application/json",
      },
      withCredentials : true
   })
   return users
}

export async function getUser(id: string) {
   const user = await axios({
      method: "get",
      url: `${API_URL}/usuarios/usuario/${id}`,
      withCredentials: true,
      headers: {},
   })
   return user
}

export async function updateUser(id: string, nombre: string, telefono: string) {
   await axios({
      method: "put",
      url: `${API_URL}/usuarios/usuario/${id}`,
      data: {
         nombre,
         telefono,
      },
      withCredentials: true,
      headers: {
         "Content-Type": "application/json",
      },
   })
}

export async function deleteUser(id:string)
{
   try
   {
      await axios({
         method: "delete",
         url :`${API_URL}/usuarios/usuario/${id}`,
         withCredentials : true
      })
   }
   catch(error)
   {
      console.error("No se pudo iniciar la peticion de eliminar usuario desde la interfaz : ",error)
   }
}

export async function sendResetPasswordEmail(email: string) {
   const response = await fetch(`${API_URL}/usuarios/${email}/sendResetPasswordEmail`, {
      method: "GET",
   })
   const data = await response.json()
   return data
}

export async function verifyEmail(email: string) {
   const response = await fetch(`${API_URL}/usuarios/verifyEmail/${email}`, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
         "Content-Type": "application/json",
         Origin: window.location.origin,
      },
   })
   const data = await response.json()
   return data
}

export async function changePassword(newPassword: string) {
   const response = await fetch(`${API_URL}/usuarios/resetPassword`, {
      method: "PUT",
      headers: {
         "Content-Type": "application/json",
         Origin: window.location.origin,
      },
      credentials: "include",
      body: JSON.stringify({
         newPassword: newPassword,
      }),
   })
   const data = await response.json()
   return data
}
